var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfConverter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#FFC1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 14.8284 18 16.2426 17.1213 17.1213C16.2426 18 14.8284 18 12 18C9.17157 18 7.75736 18 6.87868 17.1213C6 16.2426 6 14.8284 6 12C6 9.17157 6 7.75736 6.87868 6.87868C7.75736 6 9.17157 6 12 6",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.908 6.46596L16.4292 7.62013C17.4764 8.41464 18 8.81189 18 9.32783C18 9.84378 17.4764 10.241 16.4292 11.0355L14.908 12.1897C14.4475 12.5391 14.2173 12.7138 14.0287 12.6383C13.84 12.5629 13.84 12.2962 13.84 11.7628V10.9016C11.904 10.9016 9.80667 11.6885 9 13C9 8.80324 11.8682 7.75405 13.84 7.75405V6.89288C13.84 6.35945 13.84 6.09273 14.0287 6.01732C14.2173 5.94191 14.4475 6.11659 14.908 6.46596Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfConverter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-converter.457d1d9a2dde34a18e79ed29fab99d15.svg";